/* Clan Search Entry - Slideshow + Autocomplete */
(function() {
  var sections = document.querySelectorAll('[data-cs-search-entry]');
  sections.forEach(function(section) {
    var sectionId = section.getAttribute('data-section-id');
    var DATA_URL = section.getAttribute('data-search-url');
    var input = document.getElementById('csSearchEntry-' + sectionId);
    var dropdown = document.getElementById('csSearchEntryAc-' + sectionId);

    /* ---- Slideshow ---- */
    var slideCount = parseInt(section.getAttribute('data-slide-count') || '0', 10);
    var slideDuration = parseInt(section.getAttribute('data-slide-duration') || '6', 10);
    if (slideCount > 1) {
      var slides = section.querySelectorAll('.cs-search-entry__slide');
      var currentSlide = 0;
      setInterval(function() {
        slides[currentSlide].classList.remove('cs-search-entry__slide--active');
        currentSlide = (currentSlide + 1) % slides.length;
        slides[currentSlide].classList.add('cs-search-entry__slide--active');
      }, slideDuration * 1000);
    }

    /* ---- Autocomplete ---- */
    if (!input || !dropdown || !DATA_URL) return;

    var surnames = [];
    var clanLookup = {};
    var acDemand = {};
    var loaded = false;
    var debounceTimer = null;
    var activeIndex = -1;

    function loadData() {
      if (loaded) return;
      loaded = true;
      fetch(DATA_URL, { cache: 'default' })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data.surname_lookup) {
            surnames = Object.keys(data.surname_lookup);
            for (var s in data.surname_lookup) {
              var entries = data.surname_lookup[s];
              if (entries && entries.length > 0) clanLookup[s] = entries[0];
            }
          }
          if (data.clans) {
            for (var cname in data.clans) {
              if (data.clans[cname].locations && data.clans[cname].locations.length > 0)
                acDemand[cname.toLowerCase()] = 1;
            }
          }
        })
        .catch(function() {});
    }

    function getSuggestions(query) {
      if (!query || query.length < 2 || surnames.length === 0) return [];
      var q = query.toLowerCase();
      var matches = [];
      for (var i = 0; i < surnames.length; i++) {
        if (surnames[i].indexOf(q) === 0) {
          var s = surnames[i];
          var isClanName = clanLookup[s] && clanLookup[s].toLowerCase() === s;
          var demand = isClanName ? (acDemand[s] || 0) : 0;
          matches.push({ surname: s, clan: clanLookup[s] || '', isClanName: isClanName, demand: demand });
        }
      }
      matches.sort(function(a, b) {
        if (b.demand !== a.demand) return b.demand - a.demand;
        if (a.isClanName !== b.isClanName) return a.isClanName ? -1 : 1;
        return a.surname.length - b.surname.length;
      });
      return matches.slice(0, 5);
    }

    function properCase(s) {
      return s.replace(/\b\w/g, function(c) { return c.toUpperCase(); });
    }

    function showSuggestions(suggestions) {
      if (suggestions.length === 0) { dropdown.style.display = 'none'; activeIndex = -1; return; }
      var html = '';
      for (var i = 0; i < suggestions.length; i++) {
        var s = suggestions[i];
        var display = properCase(s.surname);
        var clanDisplay = s.clan && s.clan.toLowerCase() !== s.surname ? '<span class="ac-clan">' + s.clan + '</span>' : '';
        html += '<div class="cs-search-entry__ac-item" data-value="' + display + '">' + display + clanDisplay + '</div>';
      }
      dropdown.innerHTML = html;
      dropdown.style.display = 'block';
      activeIndex = -1;
      var items = dropdown.querySelectorAll('.cs-search-entry__ac-item');
      for (var j = 0; j < items.length; j++) {
        (function(item) {
          item.addEventListener('click', function(e) {
            if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
            selectItem(item);
          });
          var touchMoved = false;
          item.addEventListener('touchstart', function() { touchMoved = false; }, { passive: true });
          item.addEventListener('touchmove', function() { touchMoved = true; }, { passive: true });
          item.addEventListener('touchend', function(e) {
            if (!touchMoved) { e.preventDefault(); selectItem(item); }
          });
        })(items[j]);
      }
    }

    function selectItem(item) {
      input.value = item.getAttribute('data-value');
      dropdown.style.display = 'none';
      input.closest('form').submit();
    }

    input.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      var val = this.value.trim();
      if (val.length < 2) { dropdown.style.display = 'none'; return; }
      debounceTimer = setTimeout(function() { showSuggestions(getSuggestions(val)); }, 80);
    });

    input.addEventListener('keydown', function(e) {
      var items = dropdown.querySelectorAll('.cs-search-entry__ac-item');
      if (items.length === 0 || dropdown.style.display === 'none') return;
      if (e.key === 'ArrowDown') { e.preventDefault(); activeIndex = Math.min(activeIndex + 1, items.length - 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); activeIndex = Math.max(activeIndex - 1, -1); }
      else if (e.key === 'Enter' && activeIndex >= 0) { e.preventDefault(); selectItem(items[activeIndex]); return; }
      else if (e.key === 'Escape') { dropdown.style.display = 'none'; activeIndex = -1; return; }
      else return;
      for (var i = 0; i < items.length; i++) items[i].classList.toggle('active', i === activeIndex);
    });

    document.addEventListener('click', function(e) {
      if (!e.target.closest('.cs-search-entry__form-wrap')) { dropdown.style.display = 'none'; activeIndex = -1; }
    });

    input.addEventListener('focus', loadData, { once: true });
    input.closest('.cs-search-entry__form-wrap').addEventListener('mouseenter', loadData, { once: true });
  });
})();
